export function setJsonLd(id, data) {
  let script = document.getElementById(id);
  if (!script) {
    script = document.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(data);
}

export function setMeta(name, content, isProperty = false) {
  const attr = isProperty ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.content = content;
}

export function setPageSeo({ title, description, canonical, ogImage }) {
  document.title = title;

  const link = document.querySelector("link[rel='canonical']") || document.createElement('link');
  link.rel = 'canonical';
  link.href = canonical;
  if (!document.querySelector("link[rel='canonical']")) document.head.appendChild(link);

  setMeta('description', description);
  setMeta('og:title', title, true);
  setMeta('og:description', description, true);
  setMeta('og:url', canonical, true);
  setMeta('og:type', 'website', true);
  setMeta('og:site_name', 'Binding Thread', true);
  if (ogImage) setMeta('og:image', ogImage, true);
  setMeta('twitter:card', 'summary_large_image');
  setMeta('twitter:title', title);
  setMeta('twitter:description', description);
  if (ogImage) setMeta('twitter:image', ogImage);
}
